import { Injectable } from '@angular/core';
import { CookiesService } from '@df/core/service/cookies';
import { IMultisiteItem, MultisiteService } from '@df/core/service/multisite';
import { NgInject } from '@df/ng/ng-inject';
import { PwaNativeBridgeService } from '../module/pwa/pwa-native-bridge.service';

@Injectable({ providedIn: 'root' })
export class LocalMultisiteService extends MultisiteService {
    @NgInject(CookiesService)
    private cookies!: CookiesService;

    @NgInject(PwaNativeBridgeService)
    private pwaNativeBridgeService!: PwaNativeBridgeService;

    override get current(): IMultisiteItem {
        const current = super.current;
        this.cookies.set(
            'lm_region',
            current.siteId,
            365, // 1 year expiry
            undefined, // root path
            '.lemieux.com', // root domain
            'Lax' // SameSite=Lax allows insiders.lemieux.com to read it
        );
        this.pwaNativeBridgeService.postMessage(`setCurrentStore:${current.siteId}`);
        return current;
    }
}
